import { Link } from "react-router-dom";
import Select from "react-select";
import {
  Box,
  Text,
  Button,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
  FormControl,
  FormLabel,
  Input,
  useToast,
  Stack,
  Radio,
  RadioGroup,
  Textarea,
  Center,
} from "@chakra-ui/react";
import MeuEditor from "../Components/Editor/CKeditor";
import MeuTinyEditor from "./Editor/editor";
import api from "../services/api";
import { useState, useContext, useEffect, useRef } from "react";
import { MateriaContext } from "../contexts/Materia";
import { AiOutlineScissor } from "react-icons/ai";
import { RiScissorsCutFill } from "react-icons/ri";
import TinyMCEEditor from "../Components/Editor/TinyMCEEditor";
import { BookContext } from "../contexts/Book";
import { WarningIcon } from "@chakra-ui/icons";

const QuestionMateryList = ({ matery }) => {
  const [visibleCount, setVisibleCount] = useState(10);
  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + 10);
  };
  const { createNotebookApi, createAnswerQuestionApi } =
    useContext(BookContext);
  const {
    listQuestoesApi,
    listMateriaApi,
    listMateriaQuestoesApi,
    DetailMateriaApi,
    listSubjectsApi,
    listAllMateriaQuestoesApi,
    reportErrorApi,
  } = useContext(MateriaContext);
  const materyID = localStorage.getItem("matery_id");
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [isAnswerCorrect, setIsAnswerCorrect] = useState({});
  const [questions, setQuestions] = useState([]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState();
  const [user, setUser] = useState();
  const [isAnswerCut, setIsAnswerCut] = useState({});
  const [scissorClickedMap, setScissorClickedMap] = useState({});
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();
  const [editorContent, setEditorContent] = useState("");
  const [editorOpenMap, setEditorOpenMap] = useState({});
  const [difficultyID, setDifficultyID] = useState(0);
  const [subjects, setSubjects] = useState([]);
  const [subject, setSubject] = useState("null");
  const [answeredFilter, setAnsweredFilter] = useState();
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const editorRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedError, setSelectedError] = useState("");
  const [otherErrorText, setOtherErrorText] = useState("");
  const [questionError, setQuestionError] = useState();
  const [editorContents, setEditorContents] = useState({});
  const [localAnswers, setLocalAnswers] = useState({});

  const handleOpenEditor = (question) => {
    setEditorOpenMap((prev) => ({
      ...prev,
      [question.id]: !prev[question.id],
    }));

    // Só inicializa se ainda não existe para essa questão
    setEditorContents((prev) => ({
      ...prev,
      [question.id]: prev[question.id] ?? question.notebook?.book ?? "",
    }));
  };
  const handleReportError = async () => {
    const data = {
      question: questionError,
      type: selectedError,
      customError: otherErrorText,
    };

    try {
      await reportErrorApi(data);
      toast({
        title: "Erro enviado com sucesso",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      console.log();
      toast({
        title: "Erro ao enviar, tente novamente mais tarde",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
    setIsModalOpen(false);
    setSelectedError("");
    setQuestionError("");
    setOtherErrorText("");
  };

  const openLoginModal = () => {
    onOpen();
  };

  const handleListQuestion = (e) => {
    setAnsweredFilter(e);
    handleSelectMateria(difficultyID, subject, e);
  };
  const handleLogin = async () => {
    const data = {
      email: email,
      password: password,
    };
    try {
      const response = await api.post("auth/login", data);

      const loggedUser = response.data.user;
      const token = response.data.token;

      localStorage.setItem("user", JSON.stringify(loggedUser));
      localStorage.setItem("token", token);

      setUser(loggedUser);
      setIsLoggedIn(true);
      if (response.status === 200) {
        window.location.reload();
        setIsLoggedIn(true);
        onClose();
      }
      return response;
    } catch (error) {
      JSON.stringify(error);
      //console.log(error.data);
      window.location.reload();
      return error;
    }
  };
  const handleUpdateContent = (newContent) => {
    setEditorContent(newContent);
  };
  const handleCutAnswer = (questionId) => {
    // Verifica se a resposta já foi cortada
    const isAlreadyCut = isAnswerCut[questionId] || false;

    // Atualiza o estado isAnswerCut para indicar se a resposta foi cortada ou não
    setIsAnswerCut((prevIsAnswerCut) => ({
      ...prevIsAnswerCut,
      [questionId]: !isAlreadyCut,
    }));

    // Lógica adicional para alterar o estado do botão, texto ou outros comportamentos
    const newSelectedAnswers = { ...selectedAnswers };
    if (isAlreadyCut) {
      delete newSelectedAnswers[questionId];
    }
    setSelectedAnswers(newSelectedAnswers);
  };
  async function handleSelectMateria(difficulty, subjects, answerList) {
    const materiaID = localStorage.getItem("matery_id");
    const subjectList = subjects; // Agora é um array de assuntos
    const answered = answerList;

    //console.log(subjects);
    try {
      const materiaInfoApi = await listAllMateriaQuestoesApi(
        materiaID,
        difficulty,
        subjectList, // Passando o array de assuntos
        answered
      );
      setQuestions(materiaInfoApi.data?.questions);
    } catch (error) {
      //console.log(error);
    }
  }

  const handleChangeSubject = (selectedValues) => {
    setSelectedSubjects(selectedValues);

    const selectedIds = selectedValues.map(
      (selectedOption) => selectedOption.value
    );

    //console.log(selectedIds);
    if (selectedIds.length > 0) {
      handleSelectMateria(difficultyID, selectedIds, answeredFilter); // Envia apenas os IDs
    } else {
      handleSelectMateria(difficultyID, [], answeredFilter); // Envia um array vazio se não houver seleção
    }
  };

  async function getAssuntosMateria() {
    const materiaID = localStorage.getItem("matery_id");
    try {
      const subjectsApi = await listSubjectsApi(materiaID);
      //console.log(subjectsApi.data);
      setSubjects(subjectsApi.data?.[0]);
    } catch (error) {
      //console.log(error);
    }
  }
  function userLogged() {
    const user = JSON.parse(localStorage.getItem("user")); // Converte o JSON para objeto
    const token = localStorage.getItem("token");

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    //console.log(user);
    if (!user) {
      setIsLoggedIn(false);
      window.location.reload(); // Se o usuário não estiver logado, exiba o modal de login
    } else {
      api
        .get(`/user/${user.id}/status`, { headers })
        .then((response) => {
          setIsLoggedIn(true);
        })
        .catch((error) => {
          setIsLoggedIn(false);
          if (error.response && error.response.status === 401) {
            setIsLoggedIn(false); // Exiba o modal de login se ocorrer um erro de autenticação
          } else {
            setIsLoggedIn(true);
            window.location.reload();
          }
        });
    }
  }

  const convertOembedToIframe = (html) => {
    if (!html) return "";

    return html.replace(
      /<oembed url="https:\/\/www\.youtube\.com\/watch\?v=([^\"]+)"><\/oembed>/g,
      '<iframe width="560" height="315" src="https://www.youtube.com/embed/$1" frameborder="0" allowfullscreen></iframe>'
    );
  };

  useEffect(() => {
    userLogged();

    handleSelectMateria(null, null);
    getAssuntosMateria();
  }, [materyID]);

  const handleChangeDifficulty = (value) => {
    setSubject(null);
    handleSelectMateria(value);
    setDifficultyID(value);

    if (value > 0) {
      handleSelectMateria(value, null);
    } else {
      handleSelectMateria(null, null);
    }
  };

  const handleAnswerSelection = (questionId, answerId) => {
    setSelectedAnswers((prevSelectedAnswers) => ({
      ...prevSelectedAnswers,
      [questionId]: answerId,
    }));
  };

  const handleAnswerSubmission = async (questionId) => {
    // Obtém a resposta selecionada pelo usuário
    const selectedAnswer = selectedAnswers[questionId];
    if (!isLoggedIn) {
      // Se o usuário não estiver logado, abrir o modal de login
      openLoginModal();
      return;
    }
    // Verifica se a resposta foi selecionada
    if (!selectedAnswer) {
      return;
    }

    // Obtém a pergunta correspondente ao ID
    const question = questions.find((q) => q.id === questionId); // Corrija esta linha

    if (!question) {
      return;
    }

    const data = {
      question_id: questionId,
      answer_id: selectedAnswer,
    };
    try {
      const response = await createAnswerQuestionApi(data);
      //console.log(response.data);
      if (response.status === 200) {
        const correctAnswerIndex = question.answers.findIndex(
          (answer) => answer.answer_verify === 1
        );

        const isCorrect =
          question.answers[correctAnswerIndex].id === selectedAnswer;

        setIsAnswerCorrect((prevIsAnswerCorrect) => ({
          ...prevIsAnswerCorrect,
          [questionId]: isCorrect,
        }));

        const selectedIds = selectedSubjects.map(
          (selectedOption) => selectedOption.value
        );

        // if (selectedIds.length > 0) {
        //   handleSelectMateria(difficultyID, selectedIds, answeredFilter); // Envia apenas os IDs
        // } else {
        //   handleSelectMateria(difficultyID, [], answeredFilter); // Envia um array vazio se não houver seleção
        // }

        setLocalAnswers((prev) => ({
          ...prev,
          [questionId]: {
            selectedAnswer,
            isCorrect,
          },
        }));

        toast({
          title: "Resposta enviada com sucesso",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      //console.log(error);
      toast({
        title: "Deu algo errado",
        status: "error",
        isClosable: true,
      });
    }
  };

  const handleNotebookSave = async (value) => {
    //console.log(value);
    if (!isLoggedIn) {
      // Se o usuário não estiver logado, abrir o modal de login
      openLoginModal();
      return;
    } else {
      try {
        const userInfo = JSON.parse(localStorage.getItem("user"));
        const data = {
          question_id: value.id,
          user_id: userInfo.id,
          notebook: editorContents[value?.id] ?? "",
        };
        const response = await createNotebookApi(data);
        if (response.status == 200) {
          toast({
            title: "Caderno Atualizado com Sucesso",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
        }
      } catch (error) {
        if (error.response.status == 401) {
          toast({
            title: "Sua sessão expirou, faça o login novamente",
            status: "error",
            isClosable: true,
          });
          openLoginModal();
          return;
        }
      }
    }
  };

  const handleApplyFilters = () => {
    const selectedIds = selectedSubjects.map((s) => s.value);
    handleSelectMateria(difficultyID, selectedIds, answeredFilter);
  };
  const options = subjects.map((item) => ({
    value: item.id,
    label: item.subject,
  }));

  const optionsDific = [
    { value: "1", label: "Iniciante" },
    { value: "2", label: "Intermediário" },
    { value: "3", label: "Avançado" },
  ];

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsAnswerCorrect({});
      setIsAnswerCut({});
      setSelectedAnswers({});
    }, 3000);

    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    // Quando perguntas mudarem, sincronize as anotações do backend
    if (questions.length > 0) {
      setEditorContents((prev) => {
        const updated = { ...prev };
        questions.forEach((q) => {
          updated[q.id] = q.notebook?.book ?? "";
        });
        return updated;
      });
    }
  }, [questions]);
  return (
    <>
      <Flex justifyContent={"center"}>
        <Box borderRadius="md" p={4} width={"700px"} color={"white"}>
          <Box mb={8}>
            <Select
              options={optionsDific}
              placeholder="Selecione a dificuldade"
              onChange={(selectedOption) =>
                handleChangeDifficulty(selectedOption.value)
              }
              isSearchable
              styles={{
                control: (provided) => ({
                  ...provided,
                  background: "white",
                  borderColor: "#CBD5E0",
                  borderRadius: "0.375rem",
                  boxShadow: "none",
                  maxWidth: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  "&:hover": {
                    borderColor: "#A0AEC0",
                  },
                }),
                multiValue: (provided) => ({
                  ...provided,
                  maxWidth: "50%", // Limita a largura do badge
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }),
                menu: (provided) => ({
                  ...provided,
                  background: "white",
                  borderRadius: "0.375rem",
                }),
                option: (provided, state) => ({
                  ...provided,
                  background: state.isFocused ? "#EDF2F7" : "white",
                  color: state.isFocused ? "#2D3748" : "#4A5568",
                  "&:hover": {
                    background: "#E2E8F0",
                  },
                }),
              }}
            />
          </Box>

          <Box width="100%">
            <Select
              options={options}
              placeholder="Selecionar assunto"
              value={selectedSubjects} // O valor aqui é um array de objetos
              onChange={handleChangeSubject} // Passa o array completo de objetos
              isSearchable
              isMulti
              getOptionLabel={(e) => e.label} // Como o label é 'label' e não 'subject'
              getOptionValue={(e) => e.value} // A chave 'value' vai ser usada como valor para cada opção
              styles={{
                control: (provided) => ({
                  ...provided,
                  background: "white",
                  borderColor: "#CBD5E0", // Chakra's gray.300
                  borderRadius: "0.375rem", // Chakra's md
                  boxShadow: "none",
                  "&:hover": {
                    borderColor: "#A0AEC0", // Chakra's gray.400
                  },
                }),
                menu: (provided) => ({
                  ...provided,
                  background: "white",
                  borderRadius: "0.375rem",
                }),
                option: (provided, state) => ({
                  ...provided,
                  background: state.isFocused ? "#EDF2F7" : "white", // Chakra's gray.100
                  color: state.isFocused ? "#2D3748" : "#4A5568", // Chakra's gray.800 and gray.600
                  "&:hover": {
                    background: "#E2E8F0", // Chakra's gray.200
                  },
                }),
              }}
            />
          </Box>

          <RadioGroup
            defaultValue="all"
            onChange={(e) => handleListQuestion(e)}
          >
            <Stack direction="row" color={"#050F40"}>
              <Radio value="all">Todas</Radio>
              <Radio value="true">Respondidas</Radio>
              <Radio value="false">Não Respondidas</Radio>
            </Stack>
          </RadioGroup>
        </Box>
      </Flex>
      <Box>
        {questions?.slice(0, visibleCount).map((question, index) => {
          const correctAnswerIndex = question.answers.findIndex(
            (answer) => answer.answer_verify === 1
          );

          const questionId = question?.id;

          return (
            <>
              <Flex justifyContent="center">
                <Box key={index} my={2} width={"90vw"}>
                  <Box
                    borderWidth="1px"
                    borderRadius="md"
                    p={4}
                    width={"100%"}
                    bg={"white"}
                    color={"black"}
                    padding={"45px"}
                  >
                    <Text fontWeight="bold">Questão {index + 1}:</Text>
                    <Box mt={1} mb={5}>
                      <Box fontWeight={"bold"} fontSize={"14px"} pr={2}>
                        <Text> Materia: {matery}</Text>
                      </Box>
                      <Box fontWeight={"bold"} fontSize={"14px"}>
                        <Text>Dificuldade: {question.difficulty_name}</Text>
                      </Box>
                      <Box>
                        {question.subject != null ? (
                          <Text fontSize={"14px"} fontWeight={"bold"}>
                            Assunto: {question.subject?.subject}
                          </Text>
                        ) : (
                          ""
                        )}
                      </Box>

                      <Box display="inline-flex" flexWrap="wrap" gap="10px">
                        <Text fontSize={"14px"} fontWeight={"bold"}>
                          Assuntos Secundário:
                        </Text>
                        {question?.secondary_subjects?.map((subject) => (
                          <Text
                            fontSize="14px"
                            color={"black"}
                            key={subject.id}
                          >
                            {subject?.subject}
                          </Text>
                        ))}
                      </Box>
                    </Box>

                    <Box
                      fontSize={"18px"}
                      dangerouslySetInnerHTML={{
                        __html: question.question,
                      }}
                    />

                    {question?.answers.map((answer, index) => {
                      const localAnswer = localAnswers[question.id];

                      // Resposta do backend
                      const backendAnswer = question.my_answer?.answer_id;

                      // Verificar se tem resposta local (nesta sessão) ou backend
                      const myAnswer =
                        localAnswer?.selectedAnswer ?? backendAnswer;

                      const correctAnswer = question.answers.find(
                        (a) => a.answer_verify === 1
                      );

                      const isCorrect =
                        myAnswer && correctAnswer?.id === myAnswer;
                      const isWrong =
                        myAnswer && correctAnswer?.id !== myAnswer;
                      const isSelected =
                        selectedAnswers[question.id] === answer.id;
                      const isThisMyAnswer = myAnswer === answer.id;

                      return (
                        <Box
                          key={answer.id}
                          display="flex"
                          alignItems="center"
                          mt={2}
                          color={"black"}
                          cursor="pointer"
                          borderRadius="md"
                        >
                          {/* ✅ Ícone ✔️ ou ❌ */}
                          {isThisMyAnswer && (
                            <Box
                              ml={2}
                              color={
                                isCorrect ? "green" : isWrong ? "red" : "black"
                              }
                            >
                              {isCorrect ? "✔️" : isWrong ? "❌" : ""}
                            </Box>
                          )}

                          {/* ✅ Botão da alternativa */}
                          <Button
                            ml={2}
                            p={"0px"}
                            borderRadius={100}
                            fontSize="14px"
                            fontWeight={
                              isThisMyAnswer && isCorrect ? "bold" : "normal"
                            }
                            color={
                              isThisMyAnswer && isCorrect ? "#050F40" : "black"
                            }
                            variant={isSelected ? "solid" : "outline"}
                            colorScheme={isSelected ? "gray" : "gray"}
                            isDisabled={
                              isAnswerCut[answer.id] || isThisMyAnswer
                            }
                            onClick={() =>
                              handleAnswerSelection(question.id, answer.id)
                            }
                          >
                            {String.fromCharCode(65 + index)}
                          </Button>

                          {/* ✅ Texto da alternativa */}
                          <Box
                            ml={2}
                            flex="1"
                            css={{
                              textDecoration: scissorClickedMap[answer.id]
                                ? "line-through"
                                : "none",
                              color: scissorClickedMap[answer.id]
                                ? "#ccc"
                                : isThisMyAnswer && isCorrect
                                ? "#050F40"
                                : isThisMyAnswer && isWrong
                                ? "red"
                                : "black",
                            }}
                            fontSize="14px"
                            fontWeight={
                              isThisMyAnswer && isCorrect ? "bold" : "normal"
                            }
                            dangerouslySetInnerHTML={{ __html: answer.answer }}
                          />
                        </Box>
                      );
                    })}

                    <Box
                      display="flex"
                      flexDirection={{ base: "column", md: "row" }} // No mobile (base) = coluna (empilhado), a partir do md (768px) = linha (lado a lado)
                      justifyContent="center"
                      mt={4}
                      mb={5}
                    >
                      <Button
                        mb={{ base: 4, md: 0 }} // Margem inferior apenas no mobile
                        mr={{ base: 0, md: 5 }} // Margem à direita no desktop
                        bgColor={"#FAB929"}
                        onClick={() => {
                          setEditorOpenMap((prevEditorOpenMap) => ({
                            ...prevEditorOpenMap,
                            [question.id]: !prevEditorOpenMap[question.id], // Invert the open state
                          }));
                        }}
                      >
                        {!editorOpenMap[question.id]
                          ? "Adicionar Anotação"
                          : "Fechar Editor"}
                      </Button>
                      <Button
                        bgColor={"#FAB929"}
                        onClick={() => {
                          handleAnswerSubmission(question.id);
                          userLogged();
                        }}
                        isDisabled={!selectedAnswers[question.id]}
                      >
                        Enviar Resposta
                      </Button>
                    </Box>
                    {(() => {
                      const localAnswer = localAnswers[question.id];
                      const backendAnswer = question.my_answer?.answer_id;

                      const myAnswer =
                        localAnswer?.selectedAnswer ?? backendAnswer;
                      const correctAnswer = question.answers.find(
                        (a) => a.answer_verify === 1
                      );

                      if (!myAnswer) return null;

                      const isCorrect = correctAnswer?.id === myAnswer;
                      const isWrong = correctAnswer?.id !== myAnswer;

                      if (isCorrect) {
                        return (
                          <Box display="flex" justifyContent="start" mt={2}>
                            <Text color="green">Resposta Correta!</Text>
                          </Box>
                        );
                      }

                      if (isWrong) {
                        return (
                          <Box display="flex" justifyContent="start" mt={2}>
                            <Text color="red">Resposta Incorreta.</Text>
                          </Box>
                        );
                      }

                      return null;
                    })()}

                    <Flex justifyContent="center" flexDirection="column">
                      {/* Resto do seu código da pergunta */}
                      {editorOpenMap[question.id] && (
                        <>
                          <MeuTinyEditor
                            value={
                              editorContents[question.id] ??
                              convertOembedToIframe(question?.book)
                            }
                            onChange={(value) =>
                              setEditorContents((prev) => ({
                                ...prev,
                                [question.id]: value,
                              }))
                            }
                          />
                          <Button
                            mt={2}
                            onClick={() => handleNotebookSave(question)}
                          >
                            {" "}
                            Salvar{" "}
                          </Button>
                        </>
                      )}
                    </Flex>

                    <Flex justify="flex-end" mt={2}>
                      <Button
                        variant="link"
                        color="red.500"
                        fontSize="sm"
                        leftIcon={<WarningIcon />}
                        onClick={() => {
                          setIsModalOpen(true);
                          setQuestionError(question.id);
                        }}
                      >
                        Reportar erro
                      </Button>
                    </Flex>
                  </Box>
                </Box>
              </Flex>
            </>
          );
        })}
        {visibleCount < questions?.length && (
          <Center mt={4} my={5}>
            <Button
              bgColor={"#050F40"}
              color={"white"}
              onClick={handleLoadMore}
            >
              Carregar mais questões
            </Button>
          </Center>
        )}
        {/* Modal de login */}
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Login</ModalHeader>
            <ModalBody>
              <FormControl>
                <FormLabel>Email</FormLabel>
                <Input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </FormControl>
              <FormControl mt={4}>
                <FormLabel>Password</FormLabel>
                <Input
                  type="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </FormControl>
              <Button mt={5} onClick={handleLogin}>
                {" "}
                Login{" "}
              </Button>
            </ModalBody>
            <Box maxW={"350px"}>
              <Stack
                ml={5}
                pb={2}
                direction={{ base: "column", sm: "row" }}
                align={"start"}
                justify={"space-between"}
              >
                <Text>Ainda não tem Cadastro?</Text>

                <Link to={"/cadastro"}>
                  <Text color={"#FAB929"} fontWeight={"bold"}>
                    Cadastre-se
                  </Text>
                </Link>
              </Stack>
            </Box>
          </ModalContent>
        </Modal>

        {/* Modal de reportar erro */}
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Reportar um problema</ModalHeader>
            <ModalBody>
              <Text mb={2}>Selecione o tipo de erro:</Text>
              <RadioGroup onChange={setSelectedError} value={selectedError}>
                <Stack direction="column">
                  <Radio value="erro_de_gabarito">Erro de gabarito</Radio>
                  <Radio value="erro_de_digitacao">Erro de digitação</Radio>
                  <Radio value="questao_anulada">Questão anulada</Radio>
                  <Radio value="outro">Outro</Radio>
                </Stack>
              </RadioGroup>

              {/* Textarea aparece se "Outro" for selecionado */}
              {selectedError === "outro" && (
                <Textarea
                  mt={3}
                  placeholder="Descreva o problema..."
                  value={otherErrorText}
                  onChange={(e) => setOtherErrorText(e.target.value)}
                />
              )}
            </ModalBody>
            <ModalFooter>
              <Button
                colorScheme="blue"
                onClick={handleReportError}
                isDisabled={
                  !selectedError ||
                  (selectedError === "outro" && !otherErrorText.trim())
                }
              >
                Enviar
              </Button>
              <Button ml={2} onClick={() => setIsModalOpen(false)}>
                Cancelar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>
    </>
  );
};

export default QuestionMateryList;
